import React from 'react';
import { Route } from 'react-router-dom';
import PrivateRoute from 'src/routes/PrivateRoute';
import { InboxPage } from '../pages';

export const routes = (
  <Route
    path="/inbox"
    element={
      <PrivateRoute>
        <InboxPage />
      </PrivateRoute>
    }
  />
);
